import { CheckCircle2, ArrowRight, Star } from "lucide-react";
import Reveal from "@/components/Reveal";

const PLANS = [
  {
    testId: "pricing-tier-launchpad",
    btnTestId: "btn-select-plan-starter",
    name: "CSR Launchpad",
    tag: "For emerging NGOs",
    target: "First ₹25L – ₹50L grant",
    popular: false,
    features: [
      "CSR-1 / 80G / 12A compliance audit & packaging",
      "One boardroom-grade pitch deck & impact dossier",
      "Matching with 25–40 relevant CSR mandates",
      "Corporate introductions & proposal submissions",
      "Email + WhatsApp advisory support",
    ],
  },
  {
    testId: "pricing-tier-growth",
    btnTestId: "btn-select-plan-growth",
    name: "Scale & Growth",
    tag: "Most popular",
    target: "₹50L – ₹2.5 Cr per year",
    popular: true,
    features: [
      "Everything in CSR Launchpad",
      "Dedicated CSR outreach manager for your NGO",
      "Multi-corporate consortium structuring",
      "Boardroom representation & MoU negotiation",
      "Quarterly M&E and utilization reporting",
      "Renewal strategy for multi-year grants",
    ],
  },
  {
    testId: "pricing-tier-enterprise",
    btnTestId: "btn-select-plan-enterprise",
    name: "Institutional Enterprise",
    tag: "For established institutions",
    target: "₹5 Cr+ multi-year capital pools",
    popular: false,
    features: [
      "Everything in Scale & Growth",
      "Multi-year CSR consortium design (3+ corporates)",
      "Funder consortium governance & reporting cadence",
      "Senior advisor on your fundraising board",
      "Annual impact film & funder annual-report assets",
      "Priority access to new CSR budget cycles",
    ],
  },
];

export default function Plans({ onSelectPlan }) {
  return (
    <section id="plans" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="font-mono-alt mb-4 text-xs font-semibold tracking-[0.35em] text-[#E8862A]">04 / ASSOCIATION PLANS</p>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#C7DAF5] bg-[#EAF1FC] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#0E2A6B]">
            Association Plans
          </span>
          <h2 className="mt-5 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Choose how we <span className="font-display italic text-[#0E2A6B]">work together</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Three association frameworks based on your NGO's size and funding ambition. Every
            engagement begins with a free eligibility audit.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {PLANS.map((p) => (
            <div
              key={p.testId}
              data-testid={p.testId}
              className={`relative flex flex-col rounded-3xl border p-8 transition-all hover:-translate-y-1.5 hover:shadow-2xl ${
                p.popular
                  ? "border-[#0E2A6B] bg-[#0E2A6B] text-white shadow-xl"
                  : "border-[#E6E9E6] bg-[#FBFBF9]"
              }`}
            >
              {p.popular && (
                <span className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1 rounded-full bg-[#E8862A] px-4 py-1 text-xs font-bold uppercase tracking-wider text-white">
                  <Star className="h-3 w-3 fill-current" />
                  Most Popular
                </span>
              )}
              <p className={`text-xs font-semibold uppercase tracking-[0.16em] ${p.popular ? "text-[#E8862A]" : "text-[#E8862A]"}`}>
                {p.tag}
              </p>
              <h3 className={`mt-2 text-xl font-bold sm:text-2xl ${p.popular ? "text-white" : "text-slate-900"}`}>
                {p.name}
              </h3>
              <p className={`mt-2 font-mono-alt text-sm font-medium ${p.popular ? "text-blue-100" : "text-[#0E2A6B]"}`}>
                Target: {p.target}
              </p>
              <ul className="mt-6 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <CheckCircle2 className={`mt-0.5 h-4 w-4 shrink-0 ${p.popular ? "text-[#E8862A]" : "text-[#0E2A6B]"}`} />
                    <span className={p.popular ? "text-blue-50/90" : "text-slate-600"}>{f}</span>
                  </li>
                ))}
              </ul>
              <button
                data-testid={p.btnTestId}
                onClick={() => onSelectPlan(p.name)}
                className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all hover:-translate-y-0.5 ${
                  p.popular
                    ? "bg-white text-[#0E2A6B] hover:shadow-lg"
                    : "bg-[#0E2A6B] text-white hover:bg-[#0A1F50]"
                }`}
              >
                Select Plan & Request Callback
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
